import React from 'react'
import HomeAbout from '../container/home/HomeAbout'
import Client from '../container/home/homeClient/Client'
import HomeOne from '../container/home/HomeOne'
import HomeService from '../container/home/HomeService'
import Plans from '../container/home/Plans'
import OurClientOne from '../container/ourClient/OurClientOne'
import Slide from '../container/slide/Slide'
import Footer from '../footer/Footer'
import SEO from '../seo/SEO'
import TopNav from '../topNav/TopNav'

function Home() {
    return (
        <React.Fragment>
            <SEO title="Royality Technologies || Home" />
            <TopNav />
            <Slide />
            <HomeAbout />
            <HomeService />
            <HomeOne />
            <Plans />
            <OurClientOne />
            <Client />
            <Footer />
        </React.Fragment>
    )
}

export default Home